import { cj } from 'src/utils/classNames';

/** Matches the handle's `size-3`, in px. */
const HANDLE_SIZE = 12;

interface Props {
	progressBarPercentage: number;
}

export default function FeeTierModalProgressBar({
	progressBarPercentage,
}: Props) {
	return (
		<div className="relative">
			{/* Background track */}
			<div className="h-2 w-full overflow-hidden rounded-full bg-button-secondary-bg">
				{/* Progress fill */}
				<div
					className="h-full rounded-full bg-positive-green transition-all duration-300 ease-out-smooth"
					style={{ width: `${progressBarPercentage}%` }}
				/>
			</div>
			{/* Circular handle */}
			<div
				className={cj(
					'absolute top-1/2 size-3 -translate-y-1/2 border-2 border-container-bg',
					'transform rounded-full bg-positive-green transition-all duration-300 ease-out'
				)}
				// Inset by the share of the handle that has passed the track, so it
				// sits flush inside at both ends rather than hanging off a full bar.
				style={{
					left: `calc(${progressBarPercentage}% - ${
						(progressBarPercentage / 100) * HANDLE_SIZE
					}px)`,
				}}
			/>
		</div>
	);
}
